@if (data(); as data) {
  <div class="bg-kz-layout-featured p-3">
    <div class="flex flex-col gap-1">
      @if (data.flight?.departureSegments?.[0]; as item) {
        <div class="flex flex-row items-center gap-1">
          <mat-icon class="airline-icon" [svgIcon]="item.airlineCode | runFunction: getAirlineIconFn" />
          <div>
            {{ item.airlineName }}
          </div>
          <div class="ml-1">{{ item.flightCode }}</div>

          <app-flight-class
            [flightClass]="item.class"
            [styleClass]="'ml-1 mb-1'"
            [ticketsLeft]="data.flight.departureTicketsLeft"
            [isBlock]="data.flight.isBlock"
          />
        </div>
      }
      @if (data.flight?.returnSegments?.[0]; as item) {
        <div class="flex flex-row items-center gap-1">
          <mat-icon class="airline-icon" [svgIcon]="item.airlineCode | runFunction: getAirlineIconFn" />
          <div>
            {{ item.airlineName }}
          </div>
          <div class="ml-1">{{ item.flightCode }}</div>

          <app-flight-class
            [flightClass]="item.class"
            [styleClass]="'ml-1 mb-1'"
            [ticketsLeft]="data.flight.returnTicketsLeft"
            [isBlock]="data.flight.isBlock"
          />
        </div>
      }
    </div>
  </div>
  <div class="text-kz-primary font-bold w-full text-center mt-2 mb-3">
    {{ data.totalPrice | priceFormat: data.priceCurrency }}
  </div>
}
